var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-level", class: [_vm.packageName] },
    [
      _c("div", { staticClass: "level-bg-box" }, [
        _c("div", {
          staticClass: "level-bg arImgTran180",
          style: {
            "background-image": `url(${_vm.backgroundStyle(
              _vm.hostData.curGrade
            )})`,
          },
        }),
        _c("div", { staticClass: "level-box" }, [
          _c("div", { staticClass: "level-text" }, [
            _vm._v(
              _vm._s(_vm.$t("lang.Lv")) +
                "." +
                _vm._s(_vm.hostData.curGrade || 0)
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "level-img ar-level-img",
              style: {
                "background-image": `url(${_vm.badgeStyle(
                  _vm.hostData.curGrade
                )})`,
              },
            },
            [_vm._v(_vm._s(_vm.hostData.curGrade || 0))]
          ),
          _c("div", { staticClass: "progress-box" }, [
            _c("div", { staticClass: "progress-level text" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("lang.LV")) +
                    "." +
                    _vm._s(_vm.hostData.curWeekGrade) +
                    "(" +
                    _vm._s(_vm.$t("lang.dl.thisWeek")) +
                    ")"
                ),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("lang.LV")) +
                    "." +
                    _vm._s(
                      _vm.hostData.curWeekGrade < 10
                        ? _vm.hostData.curWeekGrade + 1
                        : _vm.hostData.curWeekGrade
                    )
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "progress-line" },
              [
                _c("van-progress", {
                  staticClass: "progress-bar",
                  attrs: {
                    "track-color": "#ebebeb",
                    "show-pivot": false,
                    percentage: _vm.percentageVal,
                    "stroke-width": "11",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "progress-tips text" }, [
              _c("span", { staticClass: "beans" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.curGradeData.weekMinIncome > 0
                        ? _vm.curGradeData.weekMinIncome
                        : 0
                    ) +
                    " "
                ),
                _c("img", {
                  staticClass: "beans-img",
                  attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                }),
              ]),
              _c("span", { staticClass: "beans-tip" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("lang.host.get")) +
                    " " +
                    _vm._s(
                      _vm.nextGradeData.weekMinIncome -
                        _vm.hostData.curWeekIncomeAmount >
                        0
                        ? _vm.nextGradeData.weekMinIncome -
                            _vm.hostData.curWeekIncomeAmount
                        : 0
                    ) +
                    " "
                ),
                _c("img", {
                  staticClass: "beans-img",
                  attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                }),
                _c("span", { staticClass: "get-bean" }, [
                  _vm._v(_vm._s(_vm.$t("lang.host.toLevelUp"))),
                ]),
              ]),
              _c("div", { staticClass: "beans" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.hostData.curGrade < 10
                        ? _vm.nextGradeData.weekMinIncome
                        : 0
                    ) +
                    " "
                ),
                _c("img", {
                  staticClass: "beans-img",
                  attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                }),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "call-income", on: { click: _vm.openPrivateDia } },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("lang.host.privateCallIncome"))),
          ]),
          _c(
            "div",
            { staticClass: "income" },
            [
              _c("div", { staticClass: "income-num-img" }, [
                _vm._v(" " + _vm._s(_vm.myPrivateCallIncome) + " "),
                _c("img", {
                  attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                }),
                _vm._v(" /" + _vm._s(_vm.$t("lang.host.min")) + " "),
              ]),
              _c("van-icon", { staticClass: "edit", attrs: { name: "edit" } }),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "week-data" }, [
        _c("div", { staticClass: "last-week week" }, [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("lang.Lv")) +
                "." +
                _vm._s(_vm.hostData.lastWeekGrade)
            ),
          ]),
          _c("span", { staticClass: "beans" }, [
            _vm._v(" " + _vm._s(_vm.hostData.lastWeekIncomeAmount) + " "),
            _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.$t("lang.host.last2WeekTip")))]),
        ]),
        _c("span", { staticClass: "line" }),
        _c("div", { staticClass: "this-week week" }, [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("lang.Lv")) +
                "." +
                _vm._s(_vm.hostData.curWeekGrade)
            ),
          ]),
          _c("span", { staticClass: "beans" }, [
            _vm._v(" " + _vm._s(_vm.hostData.curWeekIncomeAmount) + " "),
            _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.$t("lang.dl.thisWeek")))]),
        ]),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "box-title" }, [
          _vm._v(_vm._s(_vm.$t("lang.host.privileges"))),
        ]),
        _c(
          "div",
          { ref: "scrollLevelList", staticClass: "level-number" },
          _vm._l(_vm.hostData.levels, function (item, index) {
            return _c(
              "div",
              {
                key: item.index,
                ref: "item" + index,
                refInFor: true,
                class: _vm.level === item.grade ? "active" : "",
                on: {
                  click: function ($event) {
                    return _vm.handleLevel(item, index)
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("lang.Lv")) +
                    "." +
                    _vm._s(item.grade) +
                    " "
                ),
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "level-right-box" },
          _vm._l(_vm.newPrivileges, function (item, index) {
            return _c("div", { key: index, staticClass: "level-right" }, [
              _c("div", { staticClass: "right-item" }, [
                _c(
                  "div",
                  {
                    staticClass: "right-img",
                    style: {
                      background: _vm.getPrivilegeColors(_vm.level, item),
                    },
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm._f("imgPath")(item.icon), alt: "" },
                    }),
                  ]
                ),
                _c("div", { staticClass: "right-text" }, [
                  _c("div", { staticClass: "tit" }, [
                    _vm._v(" " + _vm._s(item.title) + " "),
                  ]),
                  _c("div", { staticClass: "con" }, [
                    _vm._v(" " + _vm._s(item.content) + " "),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "right-desc" }, [
                _vm.obj.grade >= _vm.map.get(String(item.privilegeType))
                  ? _c("div", [
                      item.privilegeType == 1
                        ? _c("div", { staticClass: "right-desc-val" }, [
                            _vm._v(" " + _vm._s(_vm.obj.incomePerMinute)),
                            _c("img", {
                              staticClass: "icon",
                              attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                            }),
                            _vm._v("/" + _vm._s(_vm.$t("lang.host.min")) + " "),
                          ])
                        : _vm._e(),
                      item.privilegeType == 4
                        ? _c("div", { staticClass: "right-desc-val" }, [
                            _c("img", {
                              staticClass: "icon2",
                              attrs: {
                                src: require("@/assets/packageAssets/views/P1_Girls/HostessCenter/vava/iphone.png"),
                                alt: "",
                              },
                            }),
                            _vm._v(
                              _vm._s(_vm.obj.privateVideoMatchCount) +
                                "/" +
                                _vm._s(_vm.$t("lang.sevenKeepSignin.day")) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      item.privilegeType == 6
                        ? _c("div", { staticClass: "right-desc-val" }, [
                            _vm._v(" " + _vm._s(_vm.obj.videoPassIncomeAmount)),
                            _c("img", {
                              staticClass: "icon",
                              attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                            }),
                            _vm._v(
                              "/" +
                                _vm._s(
                                  _vm.hostData.videoPassServerTimeSeconds
                                ) +
                                "s "
                            ),
                          ])
                        : _vm._e(),
                      item.privilegeType == 8
                        ? _c("div", { staticClass: "right-desc-val" }, [
                            _c("img", {
                              staticClass: "icon2",
                              attrs: {
                                src: require("@/assets/packageAssets/views/P1_Girls/HostessCenter/vava/person.png"),
                                alt: "",
                              },
                            }),
                            _vm._v(_vm._s(_vm.obj.msgLimitDay) + " "),
                          ])
                        : _vm._e(),
                    ])
                  : _c("div", { staticClass: "unlock" }, [
                      _vm.map.get(String(item.privilegeType))
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("lang.Lv")) +
                                "." +
                                _vm._s(
                                  _vm.map.get(String(item.privilegeType))
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("lang.host.toUnlock"))),
                      ]),
                    ]),
              ]),
            ])
          }),
          0
        ),
        _c("div", { staticClass: "box-title" }, [
          _vm._v(_vm._s(_vm.$t("lang.host.levelRule"))),
        ]),
        _c("div", { staticClass: "rule-tit" }, [
          _vm._v(" " + _vm._s(_vm.$t("lang.host.hostessRuleTip")) + " "),
        ]),
        _c(
          "table",
          { staticClass: "table-box" },
          [
            _c("tr", { staticClass: "header" }, [
              _c("th", [_vm._v(_vm._s(_vm.$t("lang.host.level")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("lang.mybean.weeklyIncome")))]),
            ]),
            _vm._l(_vm.hostData.levels, function (item) {
              return _c("tr", { key: item.grade, staticClass: "td-item" }, [
                _c("td", [
                  _vm._v(_vm._s(_vm.$t("lang.Lv")) + "." + _vm._s(item.grade)),
                ]),
                _c("td", [
                  _vm._v(
                    " " +
                      _vm._s(item.weekMinIncome > 0 ? item.weekMinIncome : 0) +
                      " "
                  ),
                  _c("img", {
                    attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                  }),
                ]),
              ])
            }),
          ],
          2
        ),
      ]),
      _c("Selete", {
        attrs: {
          defaultIndex: _vm.defaultIndex,
          columns: _vm.gradeRrr,
          showPop: _vm.showPri,
        },
        on: { currentChoose: _vm.currentChoose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }